/** Canonical category / subcategory key constants. */

export const CATEGORY_KEYS = {
  ALIMENTS_BOISSONS: 'food-beverages',
  SANTE_BEAUTE: 'health-beauty',
  ELECTRONIQUE: 'electronics',
  VETEMENTS_HABILLEMENT: 'clothing',
  ARTICLES_MENAGERS: 'household',
  LIVRES_MEDIA: 'books-media',
  BIJOUX_MONTRES: 'jewelry-watches',
  BOULANGERIE_PATISSERIE: 'boulangerie',
  PRODUITS_TRADITIONNELS_MAURITANIENS: 'mauritanian-traditional',
  PHARMACIE: 'pharmacy',
  AUTOMOBILE: 'automotive',
  BUREAU_SCOLAIRE: 'office-business-school',
  MAISON_JARDIN: 'home-garden',
  SPORT_PLEIN_AIR: 'sports-outdoor',
  BEBE_ENFANT: 'baby-kids',
  SOINS_PERSONNELS: 'personal-care',
  ANIMAUX_COMPAGNIE: 'pets',
  CONSTRUCTION_BRICOLAGE: 'construction-diy',
  RESTAURATION_HOTELLERIE: 'restaurant-hotel',
  MENU_RESTAURANT: 'restaurant-menu',
  TEXTILE_TISSUS: 'textiles-fabrics',
  QUINCAILLERIE: 'hardware',
  JOUETS_JEUX: 'toys-games',
  FLEURS_PLANTES: 'flowers-plants',
  INSTRUMENTS_MUSIQUE: 'music-instruments',
  ART_LOISIRS: 'art-crafts',
  VEHICULES_MOTO: 'vehicles-motorcycles',
  MATERIEL_MEDICAL: 'medical-equipment',
  PRODUITS_COSMETIQUES: 'cosmetics-beauty',
  PRODUITS_LAITIERS_SPECIALISES: 'specialty-dairy',
  EPICERIE_FINE: 'gourmet-food',
  BOISSONS_ALCOOLISEES: 'alcoholic-beverages',
  PRODUITS_SANS_GLUTEN: 'gluten-free',
  PRODUITS_BIO: 'organic-products',
  PRODUITS_HALAL: 'halal-products',
  PRODUITS_VEGETARIENS: 'vegetarian-products',
  PRODUITS_VEGANS: 'vegan-products',
};

export const SUBCATEGORY_KEYS = {
  VIANDE: 'meat',
  POISSON_FRUITS_DE_MER: 'fish-seafood',
  FRUITS_FRAIS: 'fresh-fruits',
  LEGUMES: 'vegetables',
  PRODUITS_LAITIERS: 'dairy',
  CEREALES_GRAINS: 'grains-cereals',
  BOISSONS: 'beverages',
  CONSERVES_PRESERVES: 'canned-preserved',
  EPICES_CONDIMENTS: 'spices-condiments',
  SAUCES_ASSAISONNEMENTS: 'sauces-dressings',
  SNACKS_SUCRERIES: 'snacks-sweets',
  PATES_A_TARTINER: 'spreads-toppings',
  PETIT_DEJEUNER: 'breakfast',
  SURGELES: 'frozen',
  PLATS_PREPARES: 'ready-meals',
  HUILES_MATIERES_GRASSES: 'oils-fats',
  PRODUITS_TRADITIONNELS_MAURITANIENS: 'mauritanian-traditional',
  ALIMENTATION_BEBE: 'baby-food',
  SOINS_BEBE: 'baby-care',
  HYGIENE_ENFANT: 'kids-hygiene',
  JOUETS: 'toys',
  PAINS: 'bread',
  VIENNOISERIES: 'viennoiseries',
  PATISSERIE: 'patisserie',
  SMARTPHONES: 'smartphones',
  ORDINATEURS_PORTABLES: 'computers',
  ACCESSOIRES: 'accessories',
  JEUX_VIDEO: 'gaming',
  AUDIO_VIDEO: 'audio-video',
  ELECTROMENAGER: 'home-appliances',
  MAISON_CONNECTEE: 'smart-home',
  VETEMENTS_HOMMES: 'mens',
  VETEMENTS_FEMMES: 'womens',
  VETEMENTS_ENFANTS: 'kids',
  SOINS_PERSONNELS: 'personal-care',
  COSMETIQUES: 'cosmetics',
  PRODUITS_SANTE: 'health',
  SOINS_CHEVEUX: 'hair-care',
  SOINS_PEAU: 'skincare',
  CLIMATISATION: 'climate-comfort',
  EAU_HYDRATATION: 'water-supplies',
  TRADITIONNEL_MAURITANIEN: 'traditional-food',
};
